const config = {
    server: {
        endpoint: 'https://supporter.kulturkosmos.de/api/'
    }
};

export default config;